import { apiSlice } from './apiSlice';
import {
  CountryData,
  ForgotPasswordCredentials,
  ForgotResetPasswordCredentials,
  LoginCredentials,
  LoginResponse,
  RegisterUserPayload,
  sendOtpPayload,
} from '@/types';

export interface RegisterInvestorResponse {
  message: string;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  role: string;
}
export interface sendOtpResponse {
  message: string;
}
export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    sendForgotOtp: builder.mutation<LoginResponse, ForgotPasswordCredentials>({
      query: (credentials) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    resetForgotPassword: builder.mutation<LoginResponse, ForgotResetPasswordCredentials>({
      query: (credentials) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
    registerUser: builder.mutation<RegisterInvestorResponse, RegisterUserPayload>({
      query: (payload) => ({
        url: '/auth/register',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Auth'],
    }),
    sendOtp: builder.mutation<sendOtpResponse, sendOtpPayload>({
      query: (payload) => ({
        url: '/auth/send-code',
        method: 'POST',
        body: payload,
      }),
      // invalidatesTags: ['Accounts'],
    }),
    getCountries: builder.query<CountryData, void>({
      query: () => ({
        url: '/countries',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGetCountriesQuery,
  useRegisterUserMutation,
  useSendOtpMutation,
  useLogoutMutation,
  useSendForgotOtpMutation,
  useResetForgotPasswordMutation,
} = authApi;
